---
fr:
  users:
    flash_account_disabled: Le compte a été désactivé. Contactez le support.
    flash_account_locked: Le compte a été verrouillé. Contactez le support.
    flash_account_updated: Votre compte a été mis à jour
    flash_password_reset_instructions: Nous vous enverrons un e-mail si nous trouvons un compte utilisateur correspondant
    flash_password_sent: Un nouveau mot de passe a été envoyé à
    form:
      clear_companies_confirm: Cela retire à l'utilisateur l'accès à toutes les sociétés de cette liste lors de l'enregistrement.
      clear_power_plants_confirm: Cela retire à l'utilisateur l'accès à toutes les centrales de cette liste lors de l'enregistrement.
      unlisted_companies: A aussi accès à une société que vous ne pouvez pas attribuer. Elle est conservée à l'enregistrement. | A aussi accès à {count} sociétés que vous ne pouvez pas attribuer. Elles sont conservées à l'enregistrement.
      unlisted_power_plants: A aussi accès à une centrale que vous ne pouvez pas attribuer. Elle est conservée à l'enregistrement. | A aussi accès à {count} centrales que vous ne pouvez pas attribuer. Elles sont conservées à l'enregistrement.
    locales:
      de: DE
      en: EN
      fr: FR
      nb: 'NO'
    password_notice: Laissez le champ de mot de passe vide pour conserver le mot de passe inchangé
    users: utilisateurs
